export default {
  amountDue: "Amount Due",
  amountPaid: "Amount Paid",
  amountPaying: "Amount Paying",
  discount: "Discount",
  editCustomAmount: "Edit custom amount",
  fees: "Fees",
  invoiceTotal: "Invoice Total",
  setAmount: "Set Amount",
  payCustomAmount: "Pay a custom amount",
  payFullAmount: "Pay full amount",
  paymentAmount: "Payment Amount",
  pay: "Pay",
  tax: "Tax",
  total: "Total",
  totalAmountPaying: "Total Amount Paying",
};
